import moment from 'moment';

export const getAge = dob => {
  const today = moment();
  return {
    years: today.diff(dob, 'years'),
    months: today.diff(dob, 'months') % 12
  };
};
